export const capitalized = (value: string) => {
	return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};

export const formatInitials = (s: string) => {
	return (
		s
			?.match(/(\b\S)?/g)
			?.join('')
			.match(/(^\S|\S$)?/g)
			?.join('') ?? ''
	);
};
